import { render, staticRenderFns } from "./v-exit.vue?vue&type=template&id=4660e686&scoped=true"
import script from "./v-exit.vue?vue&type=script&lang=js"
export * from "./v-exit.vue?vue&type=script&lang=js"
import style0 from "./v-exit.vue?vue&type=style&index=0&id=4660e686&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4660e686",
  null
  
)

export default component.exports